import React, { Component } from 'react';
import MUIDataTable from 'mui-datatables';
import RolePermissionManagementService from '@services/RolePermissionManagementService';
import CSVGenerator from '@components/CSVGenerator';
import SupportAlert from '@components/SupportAlert';
import { CustomDialog } from 'react-st-modal';
import UpdatePermissionDialog from '../../components/PermissionsManagement/UpdatePermissionDialog';
import PermissionRolesDialog from '../../components/PermissionsManagement/PermissionRolesDialog';
import SpinnerModal from '@components/SpinnerModal';
import { Alert, Chip, FormControl, FormControlLabel, Grid, Stack, Switch } from '@mui/material';
import styles from './permissionsmanagement.module.css';

class PermissionsManagement extends Component {
    state = {
        loading: false,
        systemPermissionsLoading: false,
        viewSystemPermissions: false,
        updateSystemPermissions: false,
        systemPermissions: [],
        surveysUserId: null,
    }

    parseJwt(token) {
        const base64Payload = token.split('.')[1];
        const payload = atob(base64Payload);
        return JSON.parse(payload.toString());
    }

    async componentDidMount() {
        this.setState({ loading: true });

        let payload = this.parseJwt(localStorage.getItem('Bearer'));
        this.setState({ surveysUserId: payload.user_id });

        await (async () => {
            return await this.reloadSystemPermissions(payload.user_id);
        })([]);

        const viewSystemPermissions = await RolePermissionManagementService.userRolesCanActionResource(
            ['ADMINISTRATOR', 'PROJECT MANAGER', 'FIELDWORK MANAGER'],
            'VIEW',
            'SYSTEM_PERMISSIONS'
        );
        this.setState({ viewSystemPermissions: viewSystemPermissions });

        const updateSystemPermissions = await RolePermissionManagementService.userRolesCanActionResource(
            ['ADMINISTRATOR', 'PROJECT MANAGER', 'FIELDWORK MANAGER'],
            'UPDATE',
            'SYSTEM_PERMISSIONS'
        );
        this.setState({ updateSystemPermissions: updateSystemPermissions });

        this.setState({ loading: false });
    }

    async reloadSystemPermissions(surveysUserId) {
        await (async () => {
            return await RolePermissionManagementService.initialiseRolesAndPermissions(surveysUserId);
        })([]);

        await (async () => {
            try {
                const systemPermissionsAll = await RolePermissionManagementService.getRdiSystemPermissions();
                this.setState({ systemPermissions: JSON.parse(JSON.stringify(systemPermissionsAll)) });
                return systemPermissionsAll;
            } catch (ex) {
                console.log('Network error loading system permissions');
            }
        })([]);

        const viewSystemPermissions = await RolePermissionManagementService.userRolesCanActionResource(
            ['ADMINISTRATOR', 'PROJECT MANAGER', 'FIELDWORK MANAGER'],
            'VIEW',
            'SYSTEM_PERMISSIONS'
        );
        this.setState({ viewSystemPermissions: viewSystemPermissions });

        this.setState({ systemPermissionsLoading: false });
    }

    async handleFlipPermissionActive(evt, setEnabled, permissionId) {
        let systemPermissions = this.state.systemPermissions;

        systemPermissions.filter((systemPermission) => systemPermission.id === permissionId)[0].active = setEnabled;
        this.setState({
            systemPermission: systemPermissions
        });

        let updatedPermissionEnvelope = {
            actionById: this.state.surveysUserId,
            rdiPermission: this.state.systemPermissions.filter((systemPermission) => systemPermission.id === permissionId)[0]
        };

        this.onUpdatePermission(evt, updatedPermissionEnvelope)

    }

    async onUpdatePermission(evt, updatedPermissionEnvelope) {

        const finalResult = await (async () => {
            const result = await RolePermissionManagementService.savePermission(updatedPermissionEnvelope);
            return result;
        })([]);

        await (async () => {
            if (finalResult !== 'Success') {
                return await SupportAlert.displayAlert('Permission not updated. ', 'Update Permission - Failed');
            } else {
                await this.reloadSystemPermissions(updatedPermissionEnvelope.actionById);
            }
        })([]);

        this.setState({ systemPermissionsLoading: false });
    }

    async handleViewPermissionRolesDialog(evt, permission) {
        let title = 'View Permission Roles : ' + permission.name ;
        await CustomDialog(
            <PermissionRolesDialog
                {...this.props}
                backButton={{ text: 'Close' }}
                permission={permission}
                surveysUserId={this.state.surveysUserId}
                systemPermissions={this.state.systemPermissions}
            />,
            {
                className: styles.editSystemPermissionsDialog,
                title: title,
                showCloseIcon: false,
                isFocusLock: true,
                isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away
            }
        );
    }

    async handleUpdatePermissionDialog(evt, permission) {
        let title = 'Update System Permission ';
        await CustomDialog(
            <UpdatePermissionDialog
                {...this.props}
                backButton={{ text: 'Cancel' }}
                nextButton={{ text: 'Update', onClick: (evt, data) => this.onUpdatePermission(evt, data) }}
                permission={permission}
                systemPermissions={this.state.systemPermissions}
                surveysUserId={this.state.surveysUserId}
            />,
            {
                className: styles.editSystemPermissionsDialog,
                title: title,
                showCloseIcon: false,
                isFocusLock: true,
                isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away
            }
        );
    }

    systemPermissionsTable() {
        let tableTitle = 'Manage System Permissions'.toUpperCase();

        let systemPermissionsTableData = [];

        let systemPermissionsColumns = [
            {
                label: "Permission ID", name: "permissionId"
                , options: {
                    // display: true,
                    display: false,
                }
            },
            { label: "Permission name", name: "permissionName" },
            { label: "Description", name: "description" },
            { label: "Action", name: "action" },
            { label: "Resource", name: "resource" },
            { label: "Permission Status", name: "active" },
            { label: "Actions", name: "actionButtons" },
        ];

        if (this.state.systemPermissions !== undefined && this.state.systemPermissions !== null && this.state.systemPermissions.length >= 0) {

            this.state.systemPermissions.sort((a, b) => a.id > b.id ? 1 : -1).map((systemPermission) => {
                let row = {
                    permissionId: systemPermission.id,
                    permissionName: systemPermission.name,
                    description: systemPermission.description,
                    action: systemPermission.action,
                    resource: systemPermission.resource,
                    active: <div>
                        <FormControl>
                            <FormControlLabel
                                control={
                                    <Switch
                                        size='small'
                                        color='primary'
                                        sx={{ m: 1 }}
                                        checked={systemPermission.active}
                                        disabled={!this.state.updateSystemPermissions}
                                        onChange={(evt) => {
                                            this.handleFlipPermissionActive(evt, !systemPermission.active, systemPermission.id)
                                        }}
                                    />
                                }
                                label={systemPermission.active ? "Active" : "Disabled"}
                            />
                        </FormControl>
                    </div>,
                    actionButtons: <div>
                        <Stack direction="column" spacing={0.5}>
                            <Chip
                                variant='outlined'
                                label='Update Permission'
                                disabled={!this.state.updateSystemPermissions}
                                onClick={evt => this.handleUpdatePermissionDialog(evt, systemPermission)} />
                            <Chip
                                variant='outlined'
                                label='View Granted Roles'
                                onClick={evt => this.handleViewPermissionRolesDialog(evt, systemPermission)} />
                        </Stack>
                    </div>
                }
                systemPermissionsTableData.push(row);
                return null;
            });
        }

        let options = {
            padding: 'none',
            size: 'small',
            rowsPerPage: 25,
            rowsPerPageOptions: [25, 50, 100],
            jumpToPage: true,
            selectableRowsHideCheckboxes: true,
            textLabels: {
                toolbar: {
                    downloadCsv: "Export to excel",
                }
            },
            onDownload: (buildHead, buildBody, columns, data) => {
                (async () => {
                    await CSVGenerator.exportTableToXLS({
                        fileName: tableTitle,
                        columnNames: columns.filter(column => column.display !== 'false').map(item => item.label),
                        fileData: data.map(row => {
                            row.data.shift();
                            return row.data;
                        })
                    })
                })([]);
                return false;
            },
        };

        return <div className={styles.flex_row_container}>
            <MUIDataTable
                title={<div className={styles.featuredItem}><h1 className={styles.featuredTitleHeader}>{tableTitle}</h1></div>}
                data={systemPermissionsTableData}
                columns={systemPermissionsColumns}
                options={options}
            />
        </div>
    }

    render() {

        if (this.state.loading === true || this.state.systemPermissionsLoading === true) {
            return <SpinnerModal settings={true} label={'Page loading ...'} />
        } else {
            return (
                <div className={styles.container_permissions} >
                    {!this.state.viewSystemPermissions
                        ? <div className={styles.featuredItem}>
                            <span className={styles.featuredTitleHeader}><h2>{'Permissions Management'}</h2></span>
                            <hr />
                            <Grid container item xs={15} >
                                <Alert variant="outlined" severity="warning">{'Your current role and permissions does not allow permissions management functions. Please contact your supervisor or system administrator.'}</Alert>
                            </Grid>
                        </div>
                        : <div>
                            <div className={styles.featuredItem}>
                                <span className={styles.featuredTitleHeader}><h2>{'Permissions Management'}</h2></span>
                                <hr />
                                <Grid container item xs={15} >
                                    
                                </Grid>
                            </div>
                            <div className={styles.featuredItem}>
                                <Grid container item xs={15} >
                                    {this.systemPermissionsTable()}
                                </Grid>
                            </div>
                        </div>
                    }
                </div>
            )
        }
    }
}
export default PermissionsManagement;